import React, { ReactElement, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { BackButton } from 'slovlex-idsk-react-components';
import {
  Col, Heading, Row, Text,
} from 'idsk-react-components';
import { useImageSize } from 'react-image-size';
import Aktualita from '../../../model/Aktualita';
import defaultImage from '../../../../assets/images/default-aktualita.svg';
import './aktualitaDetail.scss';
import dateToString from '../../../function/dateToString';

interface Props {
  aktualita: Aktualita | null | undefined,
}

const AktualitaDetail = (
  { aktualita }
    : Props,
): ReactElement => {
  const image = aktualita?.img ? process.env.REACT_APP_MAGNOLIA_API_BASE_PATH + aktualita.img : defaultImage;
  const [dimensions] = useImageSize(image);

  useEffect(() => {
    if (aktualita && aktualita.title) {
      window.parent.postMessage({
        type: 'iframe-to-parent-set-title',
        title: aktualita.title,
      }, '*');
    }
  }, [aktualita]);

  return (
    <div className="aktualita-detail">
      <div className="back-link-wrapper">
        <BackButton buttonStyle="link" />
      </div>
      <Heading
        className="page-heading"
        size="xl"
        dangerouslySetInnerHTML={
          { __html: DOMPurify.sanitize(aktualita?.title || '') }
        }
      />
      <Col width="three-quarters">
        <Row className="sub-heading">
          <Text className="label">Vypublikované: {aktualita?.vypublikovane
            ? dateToString(new Date(aktualita.vypublikovane)) : ''}
          </Text>
          <Text className="label">Autor: {aktualita?.autor}</Text>
        </Row>
        <Row className="main">
          <div className="image-wrapper">
            {dimensions && (
              <img
                className={dimensions.width > dimensions.height ? 'landscape' : 'portrait'}
                src={image}
                alt={image}
              />
            )}
          </div>
          {/* eslint-disable-next-line react/no-danger */}
          <span dangerouslySetInnerHTML={
            { __html: DOMPurify.sanitize(aktualita?.text || '') }
          }
          />
        </Row>
      </Col>
    </div>
  );
};

export default AktualitaDetail;
